import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Aside from "./Aside";
import Header from "./Header";
import { LangUpdateContext } from "./LangContext";

import ErrorBoundary from "../component/ErrorBoundary";
import { call } from "../util/action";
import { update_me } from "../util/redux/actions";
import { getStore } from "../util/redux/store";

import "./style.scss";

export const Layout = props => {
  const updateLangFn = () => {
    setLang(prevState => ({
      ...prevState,
      updateLang: !prevState.updateLang,
    }));
  };
  const [lang, setLang] = useState({
    updateLang: false,
    updateLangFn: updateLangFn,
  });
  const me = getStore().getState().me;
  const location = useLocation();

  // Keep the logged-in user's default region (me.county) fresh and as a FULL object, regardless
  // of when they last logged in or whether a profile save reduced it to a bare id. Region
  // filters read me.county to pre-select and label the region without their own backend call.
  useEffect(() => {
    const meState = getStore().getState().me;
    if (!meState || !meState.id) return;
    call({ method: "GET", url: "users/" + meState.id + "/" }, r => {
      if (r && r.id && "county" in r) {
        const cur = getStore().getState().me;
        getStore().dispatch(update_me({ ...cur, county: r.county }));
      }
    });
  }, []);

  return (
    <div className="theme-1-light">
      <LangUpdateContext.Provider value={lang}>
        <Aside />
        <div id="content" className="app-content box-shadow-z3">
          <Header me={me} />
          <div className="app-body">
            {/* Keyed by pathname: a page crash is contained here (nav stays usable)
                and the boundary resets when the route changes. */}
            <ErrorBoundary key={location.pathname}>{props.children}</ErrorBoundary>
          </div>
        </div>
      </LangUpdateContext.Provider>
    </div>
  );
};
